import React from 'react';
export function CampaignAdIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6a1 1 0 11-2 0 1 1 0 012 0zM12.414 14H13a1 1 0 100-2H9.997A.997.997 0 009 13v3a1 1 0 102 0v-.586l2.293 2.293a1 1 0 001.414-1.414L12.414 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v3h16V5a1 1 0 00-1-1H5zm15 6H4v9a1 1 0 001 1h14a1 1 0 001-1v-9z"
  }));
}